/**
 * Potree Measurements Feature Routes
 *
 * Provides access to the standalone Potree viewer with comprehensive measurement tools.
 *
 * @module potree-measurements.routes
 */

export default [
  {
    path: '/potree-measurements',
    name: 'PotreeMeasurements',
    component: () => import('./views/PotreeMeasurementsView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Potree Measurements',
      description: 'Point Cloud Measurement Tools',
      icon: 'mdi-cube-scan',
      layout: 'potree-layout'
    }
  },
  {
    path: '/cropped-measurements/:id',
    name: 'CroppedMeasurements',
    component: () => import('./views/CroppedMeasurementsView.vue'),
    meta: {
      requiresAuth: true,
      title: 'Cropped Measurements',
      description: 'Cropped Region Point Cloud Measurements',
      icon: 'mdi-crop',
      layout: 'potree-layout'
    }
  }
]